/**
 * Чистые утилиты для чтения метаданных запроса (UTM, referrer, path).
 *
 * Выделены из `LeadForm.vue`, чтобы компонент отвечал только за UI и
 * состояние полей, а side-эффектами и чтением `window` занимался
 * изолированный слой, удобный для юнит-тестов.
 */

const UTM_KEYS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content'] as const;

export type UtmExtras = Partial<Record<(typeof UTM_KEYS)[number], string>>;

/**
 * Читает UTM-параметры из `window.location.search`. Возвращает пустой
 * объект в SSR-окружении и при ошибке парсинга.
 */
export function readUtmExtras(): UtmExtras {
  if (typeof window === 'undefined') return {};
  try {
    const params = new URLSearchParams(window.location.search);
    const out: Record<string, string> = {};
    for (const key of UTM_KEYS) {
      const v = params.get(key);
      if (v) out[key] = v;
    }
    return out;
  } catch {
    return {};
  }
}

/**
 * Возвращает `document.referrer` или `undefined`, если он пуст
 * либо окружение — не браузер.
 */
export function readReferrer(): string | undefined {
  if (typeof document === 'undefined') return undefined;
  return document.referrer || undefined;
}
